import { ref, watch } from 'vue'

const storageKey = 'viewerControlsHelpHidden'

const open = ref(window.localStorage.getItem(storageKey) !== 'true')
watch(open, (visible) => {
  if (visible) window.localStorage.removeItem(storageKey)
  else window.localStorage.setItem(storageKey, 'true')
})

export default function useViewerControlsHelp() {
  return {
    open,
    toggle: () => (open.value = !open.value),
    hide: () => (open.value = false),
  }
}
